import { Grid, Dialog, Button, DialogContent } from '@mui/material'
import GetDocument from '../../../components/Documento'

const ModalDocumento = ({ data, close }) => {
  const handleFalse = () => {
    close(false)
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={true} onClose={handleFalse}>
      <DialogContent>
        <Grid container style={{ padding: 0 }}>
          <Grid item xs={12}>
            <GetDocument dsTokenArquivo={data.token} assinado={data.assinado} />
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" onClick={handleFalse}>
              fechar
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalDocumento
